
import { applicantStore } from '@/store'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ImageConstraints, LocaleMessageWithParams } from '@/commons/types'
import { ENVIRONMENT } from '@/commons/configuration'

@Component
export default class ModalBoxPhotoRequirements extends Vue {
    @Prop() proceedCallback: undefined | (() => void)
    imageSrc = ''
    age = ''

    created (): void {
        this.age = applicantStore.applicantAge != null && applicantStore.applicantAge < 7 ? 'child' : 'adult'
        this.imageSrc = require(`../../../assets/biometry/requirements_${this.age}.png`)
    }

    proceed () {
        if (typeof this.proceedCallback === 'function') {
            this.proceedCallback()
        }
    }

    get photoConstraints (): ImageConstraints {
        return ENVIRONMENT.photoConstraints
    }

    get photoRequirementsAdult (): Array<LocaleMessageWithParams> {
        return [
            {
                templateKey: 'photoRequirements.requirementsList.adult.noHeadWear'
            },
            {
                templateKey: 'photoRequirements.requirementsList.adult.getHelp'
            },
            {
                templateKey: 'photoRequirements.requirementsList.adult.camera'
            },
            {
                templateKey: 'photoRequirements.requirementsList.adult.lookStraight'
            },
            {
                templateKey: 'photoRequirements.requirementsList.adult.centerFace'
            },
            {
                templateKey: 'photoRequirements.requirementsList.adult.glasses'
            }
        ]
    }

    get photoRequirementsChild (): Array<LocaleMessageWithParams> {
        return [
            {
                templateKey: 'photoRequirements.requirementsList.child.lookStraight'
            },
            {
                templateKey: 'photoRequirements.requirementsList.child.noHeadWear'
            }
        ]
    }

    get photoRequirements (): Array<LocaleMessageWithParams> {
        return [
            {
                templateKey: 'personBiometry.photoFileAge'
            },
            {
                templateKey: 'personBiometry.photoFileSize',
                params: {
                    minSize: this.photoConstraints.minSizeText,
                    maxSize: this.photoConstraints.maxSizeText
                }
            },
            {
                templateKey: 'personBiometry.photoFileDimensions',
                params: {
                    width: this.photoConstraints.minWidth,
                    height: this.photoConstraints.minHeight
                }
            },
            {
                templateKey: 'photoRequirements.requirementsList.unedited'
            },
            {
                templateKey: 'photoRequirements.requirementsList.notScanned'
            },
            {
                templateKey: 'photoRequirements.requirementsList.background'
            },
            ...this.age === 'adult' ? this.photoRequirementsAdult : [],
            ...this.age === 'child' ? this.photoRequirementsChild : []
        ]
    }
}
